import { useRouter } from 'vue-router'
import { useAppStore } from '@/stores/AppStore'
import { useClinicRepository } from '@/repositories/clinicRepo'

export async function authenticate() {
  const appStore = useAppStore()
  if (appStore.patient) return

  const repository = useClinicRepository(appStore.clinicUUID)
  const router = useRouter()

  try {
    const patient = await repository.fetchPatientMiniInfo()
    appStore.setPatient(patient)
  } catch (error) {
    await router.replace({
      name: 'AccountLink',
      query: {
        c: appStore.clinicUUID,
        liffId: appStore.liffId,
        clinicType: appStore.clinicType,
        channelId: appStore.channelId,
      },
    })
  }
}
